import axios from 'axios';

const isProd = process.env.NODE_ENV === 'production';

const getMeta = () => {
    return new Promise((resolve, reject) => {
        axios
            .get(isProd ? '/api/meta' : '/server/meta.json')
            .then(res => {
                resolve(res.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

const getVacancies = () => {
    return new Promise((resolve, reject) => {
        axios
            .get(isProd ? '/api/vacancies' : '/server/vacancies.json')
            .then(res => {
                resolve(res.data);
            })
            .catch(error => {
                reject(error);
            });
    });
};

export {getMeta, getVacancies};

export default {getMeta, getVacancies};
